<template>
  <div>
    <div style="width: 1300px; margin: auto">
      <div style="width: 1300px; margin: auto">
        <div style="width: 100%; height: 150px; border: 1px #000 solid">
          <span>gene : {{ value2 }}</span>
          <br />
        </div>
        <div style="margin: 10px 0 60px 0">
          <!--搜索栏，页面大小调整栏-->
          <el-col :span="8">
            <el-input
              v-model="userInput"
              @input="inputContent"
              style="width: 500px"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-col>
          <div style="width: 15%; float: right">
            <!-- 调整页面大小 -->
            Show
            <el-dropdown @command="changeValue">
              <el-button type="info" size="small">
                <span>{{ queryInfo.pagesize }}</span
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in option"
                  :key="item.value"
                  :command="item.label"
                  ><span> {{ item.label }}</span></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            entries
          </div>
        </div>
        <div>
          <el-table
            :data="list"
            id="educe-table"
            style="width: 100%"
            highlight-current-row
            justify="center"
            stripe
            @sort-change="sortChange"
          >
            <el-table-column
              prop="geneName"
              label="geneName"
              width="150"
              sortable="custom"
            ></el-table-column>

            <el-table-column
              prop="assembly"
              label="assembly"
              width="150"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="protein"
              label="protein"
              width="150"
              sortable="custom"
            ></el-table-column>

            <el-table-column
              prop="definition"
              label="definition"
              width="150"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="genesGroup"
              label="genesGroup"
              width="150"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="length"
              label="length"
              width="100"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="location"
              label="location"
              width="150"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="locus"
              label="locus"
              width="100"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="lowerQuartile"
              label="lowerQuartile"
              width="150"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="upperQuartile"
              label="upperQuartile"
              width="150"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="median"
              label="median"
              width="100"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="organismName"
              label="organismName"
              width="250"
              sortable="custom"
            ></el-table-column>
          </el-table>
        </div>
        <div
          class="block"
          style="margin-top: 20px; width: 600px; display: inline-block"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="queryInfo.pagesize"
            layout="prev, pager, next, jumper"
            :total="total"
            :current-page.sync="queryInfo.pagenum"
          >
          </el-pagination>
        </div>
        <span style="margin-top: 20px; float: right; margin-right: 150px"
          >Showing {{ total == 0 ? 0 : (queryInfo.pagenum - 1) * 10 + 1 }} to
          {{
            queryInfo.pagenum * queryInfo.pagesize > total
              ? total
              : queryInfo.pagenum * queryInfo.pagesize
          }}
          of {{ total }} entries</span
        >
      </div>
    </div>
    </div>
</template>
    <script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "GeneName",
  components: {  },
  data() {
    return {
      userInput: "",
      assembly: "",
      queryInfo: {
        pagenum: 1, //当前页面
        pagesize: 10, //页面大小
      },
      list: [],
      total: 0,
      option: [
        //页面大小
        { label: 10, value: 0 },
        { label: 25, value: 1 },
        { label: 50, value: 2 },
        { label: 100, value: 3 },
      ],
      sort: "",
      method: "",
      value2: "",
      genesTreeList: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let that = this;
      this.value2 = sessionStorage.getItem("value2");
      if (this.value2.slice(-1) == "/") this.value2 = this.value2.slice(0, -1);
      this.genesTreeList = this.value2.split("/");
      this.assembly = sessionStorage.getItem("assembly");
      const { data: res } = await this.$axios.get("/api/api.tree/gene", {
        params: {
          assembly: this.assembly,
          page: 1,
          pageSize: this.queryInfo.pagesize,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
          genesTreeList: this.genesTreeList,
        },
        paramsSerializer: function (params) {
          return that.$qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      console.log(res);
      this.list = res.data.rows;
      this.total = res.data.count;
    },
    async inputContent(e) {
      let that = this;
      this.userInput = e;
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.tree/gene", {
          params: {
            assembly: this.assembly,
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            sort: this.sort,
            method: this.sortMethod,
            genesTreeList: this.genesTreeList,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        // 赋值
        this.queryInfo.pagenum = 1;
        this.total = res.data.count;
        this.list = res.data.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async changeValue(e) {
      //改变页面大小
      this.queryInfo.pagesize = e;
      this.handleCurrentChange(1);
    },
    async handleCurrentChange(val) {
      //底部分页按钮
      let that = this;
      const { data: res } = await this.$axios.get("/api/api.tree/gene", {
        params: {
          assembly: this.assembly,
          page: val,
          pageSize: this.queryInfo.pagesize,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
          genesTreeList: this.genesTreeList,
        },
        paramsSerializer: function (params) {
          return that.$qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      // 赋值
      this.queryInfo.pagenum = val;
      this.list = res.data.rows;
      console.log(res);
    },
    async sortChange(object) {
      let that = this;
      this.sort = object.prop;
      if (object.order == "descending") {
        this.sortMethod = "DESC";
      } else if (object.order == "ascending") {
        this.sortMethod = "ASC";
      }
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.tree/gene", {
          params: {
            assembly: this.assembly,
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            sort: this.sort,
            method: this.sortMethod,
            genesTreeList: this.genesTreeList,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        // 赋值
        this.queryInfo.pagenum = 1;
        this.total = res.data.count;
        this.list = res.data.rows;
      } catch (err) {
        console.log(err);
      }
      console.log(object);
    },
  },
};
</script>
    <style scoped>
</style>